import { render, staticRenderFns } from "./Allowances.vue?vue&type=template&id=a96aa528&lang=pug&"
import script from "./Allowances.vue?vue&type=script&lang=js&"
export * from "./Allowances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports